import { DebugConfig } from '../config/DebugConfig';

/* ------------- API ------------- */
// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.

// Create the API instance
const apiInstance = DebugConfig.useFixtures 
  ? require('../services/FixtureApi').default 
  : require('../services/Api').default.create();

// Set the token from localStorage if it exists (for web persistence)
if (typeof window !== 'undefined' && !DebugConfig.useFixtures) {
  const token = localStorage.getItem('accessToken');
  if (token && typeof apiInstance.setUserToken === 'function') {
    apiInstance.setUserToken(token);
  }
}

export const api = apiInstance;
